import { motion } from "framer-motion";
import {
  BookOpen, FileText, Package, Receipt, Calculator,
  BarChart3, Users, ShieldCheck, Truck, FileSpreadsheet,
  Layers, ClipboardList
} from "lucide-react";

const features = [
  { icon: BookOpen, title: "Ledgers & Journals", desc: "Complete double-entry bookkeeping with ledger groups and journal entries" },
  { icon: Receipt, title: "GST Accounting", desc: "Auto GST calculations, GSTR filing support, HSN/SAC codes" },
  { icon: FileText, title: "Invoice Management", desc: "Multiple invoice templates, e-invoicing, and bulk operations" },
  { icon: Package, title: "Inventory Management", desc: "Stock tracking, godowns, batch management, and reorder alerts" },
  { icon: Truck, title: "E-Way Billing", desc: "Generate and manage e-way bills directly from invoices" },
  { icon: Calculator, title: "Purchase & Sales", desc: "Complete purchase and sales cycle with voucher management" },
  { icon: BarChart3, title: "Financial Reports", desc: "Balance Sheet, P&L, Trial Balance, Cash Flow statements" },
  { icon: Users, title: "Multi-User Collaboration", desc: "Company Admin, CA, and Accountant roles with permissions" },
  { icon: ShieldCheck, title: "Audit Logs", desc: "Complete audit trail for every accounting entry and action" },
  { icon: FileSpreadsheet, title: "Export Reports", desc: "Export to Excel, PDF with customizable report formats" },
  { icon: Layers, title: "Multi-Company", desc: "Manage multiple companies from a single dashboard" },
  { icon: ClipboardList, title: "Contra & Receipts", desc: "Full voucher types: receipt, payment, contra, and more" },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-display text-foreground mb-4">
            Everything You Need to Run Your Books
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From basic bookkeeping to advanced GST compliance — AccouPro covers the full accounting cycle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {features.map((feature, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="p-6 rounded-lg bg-card border border-border hover:border-accent/30 transition-all duration-300 shadow-card hover:shadow-elevated group"
            >
              <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
                <feature.icon className="h-5 w-5 text-accent" />
              </div>
              <h3 className="text-lg font-semibold font-display text-foreground mb-2">{feature.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
